module.exports = __webpack_public_path__ + "static/img/Haoyue_GUO.d023ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Haoyue_GUO.png
// module id = VNLU
// module chunks = 1